import {
    RECEIVE_INVOICES_GAS,
    SET_ITEMS_OFFSET_GAS,
    SET_FILTERS_GAS,
    CLEAR_INVOICE_PAGINATION_GAS,
    RECEIVE_INVOICES_FILTER_GAS,
    FETCH_INVOICES_REQUEST_GAS,
    FETCH_INVOICES_FILTER_REQUEST_GAS,
    EXPORT_INVOICE_REQUEST_GAS,
    EXPORT_INVOICE_DONE_GAS,
    MESSAGE_INVOICE_GAS,
    LOGOUT_SUCCESS
} from '../../../constants';
import { createReducer } from '../../../utils/misc';
import Settings from "../../../settings";

const initialState = {
    data: {},
    isFetching: false,
    loaded: false,
    download_status: {},
    invoice_function: null,
    itemsPage: Settings?.invoices?.itemsPerPage ?? 100,
    itemsTotal: 0,
    itemsOffset: 0,
    filters: {
        loading: false,
        data: {},
        currentFilter: ''
    },
    errors: null
};

export default createReducer(initialState, {
    [RECEIVE_INVOICES_GAS]: (state, payload) =>
    {
        return Object.assign({}, state, {
            items: payload.response.items,
            itemsTotal: payload.response.n_items,
            itemsOffset: payload.response.offset,
            itemsPage: payload.response.limit,
            isFetching: false,
            loaded: true,
            message_text: payload.message,
            errors: payload.errors,
        })
    },
    [SET_ITEMS_OFFSET_GAS]: (state, payload) =>
      Object.assign({}, state, {
        itemsOffset: payload.itemsOffset
      }),
    [SET_FILTERS_GAS]: (state, payload) =>
      Object.assign({}, state, {
        itemsPage: payload.itemsPage,
        itemsOffset: payload.itemsOffset,
        filters: {
            ...state.filters,
            currentFilter: payload.currentFilter
        }
      }),
    [CLEAR_INVOICE_PAGINATION_GAS]: (state, payload) =>
      Object.assign({}, state, {
        itemsPage: Settings?.invoices?.itemsPerPage ?? 100,
        itemsTotal: 0,
        itemsOffset: 0,
      }),
    [RECEIVE_INVOICES_FILTER_GAS]: (state, payload) =>
      Object.assign({}, state, {
        filters: {
          ...state.filters,
          loading: false,
          data: payload
        }
      }),
    [FETCH_INVOICES_REQUEST_GAS]: (state, payload) =>
    {
        return {
            ...state,
            isFetching: true,
            loaded: false,
            message_text: payload.message,
        }
    },
    [FETCH_INVOICES_FILTER_REQUEST_GAS]: (state, payload) =>
      Object.assign({}, state, {
        filters: {
          ...state.filters,
          loading: true,
          data: {}
        }
      }),
    [EXPORT_INVOICE_REQUEST_GAS]: (state, payload) => {
        const download_status = Object.assign({}, state.download_status);
        download_status[payload.invoice] = true;
        return Object.assign({}, state, {
            download_status,
            message_text: payload.message
        });
    },
    [EXPORT_INVOICE_DONE_GAS]: (state, payload) => {
        const download_status = Object.assign({}, state.download_status);
        download_status[payload.invoice] = false;
        return Object.assign({}, state, {
            download_status
        });
    },
    [MESSAGE_INVOICE_GAS]: (state, payload) => {
        return Object.assign({}, state, {
            message_text: payload.message,
        })
    },
    [LOGOUT_SUCCESS]: (state, payload) =>
        Object.assign({}, state, initialState),
});
